export default {
  ratePlanType: {
    STANDARD: 'มาตรฐาน',
    BAR: 'ราคาที่ดีที่สุด',
    CORPORATE: 'สำหรับองค์กร',
    MEMBER: 'สมาชิก',
    PACKAGE: 'แพ็กเกจ',
    PROMOTIONAL: 'โปรโมชั่น',
    OTA: 'OTA',
    WHOLESALE: 'ขายส่ง',
    NEGOTIATED: 'ราคาตกลงพิเศษ',
    MIXED: 'ราคาผสม',
  },
} as const;
